// ======================================================================
// File Name       : UserHistoryStudentAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ModalIds from '../constants/ModalIds';
import { openModal } from './ModalAction';
import * as ActionTypes from '../constants/actionTypes/userHistoryStudent';
import * as groupRequests from './httpRequests/group';
import * as userHistoryStudentRequests from './httpRequests/userHistoryStudent';
import * as userHistoryStudentAction from './actionCreators/userHistoryStudent';
import * as GroupAction from './GroupAction';
import { convertObjectGroupRelationToUserList } from '../utils/UserUtils';
import { RETURN_MAX_NUM, SELECT_TARGET_DATA } from '../constants/index';
import { USER_TYPE } from '../constants/UserConstants';
import { CONTENT_TYPE } from '../constants/ContentConstant';
import * as itemRequests from './httpRequests/item';

export function openGroupSelectDialog() {
  return (dispatch, getState) => {
    dispatch(openModal(ModalIds.SELECT_GROUP_USER_HISTORY_DIALOG));
  };
}

export function fetchGroupStructure() {
  return dispatch =>
    groupRequests
      .postGroupGetStructure()
      .then(({ groupList }) => dispatch(doReceiveGroupStructureList(groupList)));
}

function doReceiveGroupStructureList(groupList) {
  return {
    type: ActionTypes.USER_HISTORY_STUDENT_GET_GROUP_LIST,
    groupList,
  };
}

export function getGroupRelationList(userList, shouldNotSearchUserList) {
  const param = {
    searchInfo: {
      userList,
    },
    selectTargetData: SELECT_TARGET_DATA.DATA,
  };
  return dispatch =>
    userHistoryStudentRequests
      .postUserGroupRelationGetList(param)
      .then(({ groupRelationList, recordNum }) => {
        dispatch(
          userHistoryStudentAction.receiveGetGroupRelationList(groupRelationList, recordNum),
        );
        dispatch(getCourseByUserList(userList));
      });
}

export function getUserListFromGroupRelation(groupRelationList, shouldNotSearchUserList) {
  const userList = convertObjectGroupRelationToUserList(groupRelationList);
  return (dispatch) => {
    if (!shouldNotSearchUserList) {
      dispatch(getUserList(userList));
    }
    dispatch(getCourseByUserList(userList));
  };
}

export function getUserList(userSecernIdList) {
  const param = {
    searchInfo: {
      userSecernIdList,
    },
    selectTargetData: SELECT_TARGET_DATA.DATA,
  };
  return dispatch =>
    userHistoryStudentRequests
      .postUserGetList(param)
      .then(({ userList }) => dispatch(userHistoryStudentAction.receiveGetUserList(userList)));
}

export function getUserListBySearch(
  userName,
  groupSecernId,
  dormantState,
  userSortType,
  ascendingDescendingSort,
  startPosition,
  returnMaxNum,
  selectTargetData,
) {
  const param = {
    selectTargetData,
    searchInfo: {
      userName,
      groupList: groupSecernId ? [groupSecernId] : null, // #6098
      userSortType,
      ascendingDescendingSort,
      startPosition,
      returnMaxNum,
      dormantState,
      userType: USER_TYPE.STUDENT,
    },
  };
  if (!dormantState) {
    param.searchInfo.dormantState = 0;
  } else {
    param.searchInfo.dormantState = null;
  }
  return dispatch =>
    userHistoryStudentRequests
      .postUserGetList(param)
      .then(({ userList, csvfileUrl, recordNum }) => {
        dispatch(userHistoryStudentAction.receiveGetUserList(userList, recordNum));
        if (userList && userList.length) {
          dispatch(getGroupRelationListBySearch(userList, true));
        }
      });
}

export function initUserHistoryDetail(userSecernId) {
  return async (dispatch, getState) => {
    let userList = [];
    let userSecernIdList = [];
    let groupRelationList = [];
    let newGroupList = [];
    let param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
      searchInfo: {
        userSecernIdList: [userSecernId], // #6101
      },
    };
    const userListRes = await userHistoryStudentRequests.postUserGetList(param);
    if (userListRes && userListRes.userList && userListRes.userList.length) {
      userList = userListRes.userList;
      userSecernIdList = userList.reduce((acc, cur) => {
        if (cur && cur.userSecernId) {
          acc.push(cur.userSecernId);
        }
        return acc;
      }, []);
    }
    if (userSecernIdList && userSecernIdList.length) {
      param = {
        searchInfo: {
          userList: userSecernIdList,
        },
        selectTargetData: SELECT_TARGET_DATA.DATA,
      };
      const groupRelationRes = await userHistoryStudentRequests.postUserGroupRelationGetList(param);
      if (
        groupRelationRes &&
        groupRelationRes.groupRelationList &&
        groupRelationRes.groupRelationList.length
      ) {
        groupRelationList = groupRelationRes.groupRelationList;
      }
    }
    const { userHistoryData: { groupList } } = getState().userHistoryStudent;
    if (!groupList || !groupList.length) {
      const groupListRes = await groupRequests.postGroupGetStructure();
      if (groupListRes && groupListRes.groupList && groupListRes.groupList.length) {
        newGroupList = groupListRes.groupList;
      }
    } else {
      newGroupList = groupList;
    }

    return dispatch(
      userHistoryStudentAction.receiveUserHistoryDetailInitData(
        userList,
        groupRelationList,
        newGroupList,
      ),
    );
  };
}

export function exportUserList(searchInfo, selectTargetData) {
  const param = {
    selectTargetData,
    searchInfo,
  };

  return dispatch => userHistoryStudentRequests.postGetHistoryListByCourseList(param);
}

export function getGroupRelationListBySearch(userList, shouldNotSearchUserList) {
  let userSecernIdList = [];
  if (Object.prototype.toString.call(userList) === '[object Array]') {
    userSecernIdList = userList.reduce((acc, cur) => {
      if (cur && cur.userSecernId) {
        acc.push(cur.userSecernId);
      }
      return acc;
    }, []);
  }
  return (dispatch) => {
    dispatch(getGroupRelationList(userSecernIdList, shouldNotSearchUserList));
  };
}

export function getCourseByUserList(
  userList,
  isUserHistoryDetail,
  startPosition,
  returnMaxNum,
  learningHistorySortType,
  ascendingDescendingSort,
  selectTargetData,
  initCourseSecernId,
) {
  return (dispatch) => {
    if (isUserHistoryDetail) {
      const param = {
        searchInfo: {
          userList,
          currentCourseRelationStatus: 1,
        },
        selectTargetData: SELECT_TARGET_DATA.DATA,
      };
      userHistoryStudentRequests.postGetCourseByUserList(param).then(({ courseStatusList }) => {
        dispatch(userHistoryStudentAction.receiveGetCourseByUserList(courseStatusList));
        if (courseStatusList && courseStatusList.length) {
          // get course list by course id
          const courseList = [];
          courseStatusList.forEach((item) => {
            courseList.push(item.courseSecernId);
          });
          if (courseList && courseList.length) {
            dispatch(getUserHistoryCourseInfoList(courseList, SELECT_TARGET_DATA.DATA)).then(() => {
              // get first course item to get student history list
              let courseSecernId = courseStatusList[0].courseSecernId;
              if (initCourseSecernId) {
                courseSecernId = initCourseSecernId;
              }
              dispatch(
                getHistoryListBySearch(
                  userList,
                  [courseSecernId],
                  startPosition || 0,
                  returnMaxNum || RETURN_MAX_NUM,
                  !isNaN(learningHistorySortType) ? learningHistorySortType : null,
                  !isNaN(ascendingDescendingSort) ? ascendingDescendingSort : null,
                  selectTargetData || SELECT_TARGET_DATA.DATA,
                ),
              );
            });
          }
        } else {
          const courseList = [];
          dispatch(userHistoryStudentAction.resetLearningHistoryList());
          dispatch(userHistoryStudentAction.receiveGetUserHistoryCourseInfoList(courseList));
          dispatch(userHistoryStudentAction.receiveGetCourseByUserList(courseStatusList));
        }
      });
    } else {
      const param = {
        searchInfo: {
          userList,
        },
        selectTargetData: SELECT_TARGET_DATA.DATA,
      };
      userHistoryStudentRequests.postEachUserCourseStatusCount(param).then(({ courseStatusList }) => {
        dispatch(userHistoryStudentAction.receiveEachUserCourseStatusCount(courseStatusList));
      });
    }
  };
}

export function getUserHistoryCourseInfoList(courseListData, selectTargetData) {
  const param = {
    searchInfo: {
      courseList: courseListData,
    },
    selectTargetData,
  };
  return dispatch =>
    userHistoryStudentRequests
      .postGetCourseList(param)
      .then(({ courseList }) =>
        dispatch(userHistoryStudentAction.receiveGetUserHistoryCourseInfoList(courseList)),
      );
}

export function getHistoryListBySearch(
  userList,
  courseList,
  startPosition,
  returnMaxNum,
  learningHistorySortType,
  ascendingDescendingSort,
  selectTargetData,
) {
  const searchInfo = {
    userList: userList && userList.length > 0 ? userList : null,
    courseList: courseList && courseList.length > 0 ? courseList : [],
    startPosition: startPosition || 0,
    returnMaxNum: returnMaxNum || RETURN_MAX_NUM,
    learningHistorySortType,
    ascendingDescendingSort,
  };
  const param = {
    searchInfo,
    selectTargetData,
  };
  return dispatch =>
    userHistoryStudentRequests
      .postGetHistoryListByCourseList(param)
      .then(({ learningHistoryList, recordNum }) => {
        if (selectTargetData === SELECT_TARGET_DATA.DATA) {
          dispatch(
            userHistoryStudentAction.receiveGetHistoryListByCourseList(
              learningHistoryList,
              recordNum,
            ),
          );
          if (learningHistoryList && learningHistoryList.length) {
            const contentSecernIdList = [];
            const itemSecernIdList = [];
            learningHistoryList.forEach((item) => {
              contentSecernIdList.push(item.contentSecernId);
              if (item.contentType === CONTENT_TYPE.DRILL) {
                itemSecernIdList.push(item.itemSecernId);
              }
            });
            if (contentSecernIdList && contentSecernIdList.length) {
              dispatch(getContentList(contentSecernIdList));
            }
            if (itemSecernIdList && itemSecernIdList.length) {
              const searchInfoData = {
                itemList: itemSecernIdList,
              };
              dispatch(getItemList(searchInfoData));
            }
          }
        }
      });
}

export function getItemList(searchInfoData) {
  return dispatch =>
    itemRequests
      .postItemGetList({
        searchInfo: searchInfoData,
        selectTargetData: SELECT_TARGET_DATA.DATA,
      })
      .then((result) => {
        dispatch(userHistoryStudentAction.receiveItemList(result));
      });
}

export function getCourseList(courseListData, selectTargetData) {
  const param = {
    searchInfo: {
      courseList: courseListData,
    },
    selectTargetData,
  };
  return dispatch =>
    userHistoryStudentRequests
      .postGetCourseList(param)
      .then(({ courseList }) =>
        dispatch(userHistoryStudentAction.receiveGetCourseList(courseList)),
      );
}

export function getContentList(listContent) {
  const param = {
    searchInfo: {
      contentList: listContent,
      excludeQuestion: true,
    },
  };
  return dispatch =>
    userHistoryStudentRequests
      .postGetContentList(param)
      .then(({ contentList }) =>
        dispatch(userHistoryStudentAction.receiveGetContentList(contentList)),
      );
}

function receiveDrillEnforceHistoryByHash(drillResult, partQuestionRecordByUserList) {
  let partQuestionList = [];
  if (partQuestionRecordByUserList && partQuestionRecordByUserList.length) {
    partQuestionList = partQuestionRecordByUserList;
  }
  return userHistoryStudentAction.receiveDrillEnforceHistoryByHash(drillResult, partQuestionList);
}

export function getStudentResult(params) {
  return (dispatch) => {
    userHistoryStudentRequests.requestDrillEnforceHistoryInfoByHash(params).then((resData) => {
      if (resData && resData.drillHistory && resData.drillHistory.length) {
        if (resData.drillHistory[0] && resData.drillHistory[0].drillResultInfo) {
          const drillResultInfo = resData.drillHistory[0].drillResultInfo;
          if (drillResultInfo.questionResultList && drillResultInfo.questionResultList.length) {
            const questionResultList = drillResultInfo.questionResultList;
            const length = questionResultList.length;
            const questionRecordByUserList = [];
            const partQuestionRecordByUserList = [];
            for (let i = 0; i < length; i++) {
              if (questionResultList[i].answerJudgeResult) {
                const result = parseInt(questionResultList[i].answerJudgeResult, 10);
                if (result === 99 || questionResultList[i].subQuestionArray.length) {
                  questionResultList[i].drillSecernId = resData.drillHistory[0].drillSecernId;
                  questionResultList[i].drillKind = resData.drillHistory[0].drillKind;
                  partQuestionRecordByUserList.push(questionResultList[i]);
                }
              }
            }
            dispatch(receiveDrillEnforceHistoryByHash(resData.drillHistory[0], partQuestionRecordByUserList));
          }
        }
      } else {
        dispatch(receiveDrillEnforceHistoryByHash(null, null));
      }
    });
  };
}

export function getQuestionHistoryReviewHtml(params) {
  return dispatch =>
    userHistoryStudentRequests.requestQuestionHistoryReviewHtml(params).then(
      redirectUri =>
        // return dispatch(receiveQuestionReviewHtml(redirectUri));
        redirectUri,
    );
}

function receiveQuestionReviewHtml(redirectUri) {
  return userHistoryStudentAction.receiveQuestionHistoryReviewHtml(redirectUri);
}

export function saveHistoryCourseDetail(courseDetail) {
  return async dispatch => dispatch(userHistoryStudentAction.saveHistoryCourseDetail(courseDetail));
}

export function resetHistoryCourseDetail() {
  return async dispatch => dispatch(userHistoryStudentAction.resetHistoryCourseDetail());
}

export function resetCourseStatusList() {
  return dispatch => dispatch(userHistoryStudentAction.resetCourseStatusList());
}
